jQuery(function ($) {
  //var booksIntro = $('.row.books').find('.books_intro').outerHeight();
  //document.styleSheets[0].addRule('.row.books::after','top: '+ (booksIntro + 125) +'px !important;');

  $('.tabs .nav-tabs .nav-item').on('click', function() {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active').siblings().removeClass('active');
    }
  });

  $('.navbar-toggler').on('click', function() {
    $(this).toggleClass('active');
    $('#mobile-nav').toggleClass('open');
    if ($('.mobile-subnav').hasClass('open')) {
      $('.mobile-subnav').removeClass('open');
    }
  });

  $('.mobile-subnav-toggler').on('click', function() {
    $('.mobile-subnav').toggleClass('open');
  });

  var lastScrollTop = 0;
  $(window).scroll(function(event){
     var st = $(this).scrollTop();
     var $mobileSubnav = $('.mobile-subnav');
     if (st > lastScrollTop){
        $mobileSubnav.addClass('hidden');
     } else {
        $mobileSubnav.removeClass('hidden');
     }
     lastScrollTop = st;
  });

  $('.vote_form_wrapper input[type="submit"]').css('display', 'none');
  // empty object to store chosen items
  var chosenItems = {};
  var placeholder = $('.main_vote_form').find('.book_cover > img').attr('src');
  $(document).on('click', '.vote_item', function(e) {
    e.preventDefault();
    $('.vote_form_wrapper input[type="submit"]').css('display', 'block');
    // store some variables
    var $item = $(this);
    var id = $item.data('postid');
    var pos = $item.data('position');
    var current = false;
    var $current = $item.siblings('.chosen');
    // if there's already a chosen item for this position, store it
    if (pos !== 4) {
      if ($current.length) {
        current = {
          id: $current.data('postid'),
          position: $current.data('position'),
          title: $current.find('.vote_item_title').text(),
          author: $current.find('vote_item_author').text()
        };
      } else {
        current = {
          id: 'custom-' + pos
        };
      }
      // store the currently selected ietm
      var item = {
        id: $item.data('postid'),
        position: $item.data('position'),
        title: $item.find('.vote_item_title').text(),
        author: $item.find('.vote_item_author').text()
      };
      // check for duplicate
      var duplicate = false;
      $.each(chosenItems, function(key, value) {
        if (value.title.toLowerCase() === item.title.toLowerCase() && value.author.toLowerCase() === item.author.toLowerCase()) {
          duplicate = true;
        }
      });
      if (!duplicate) {
        // empty duplicate notice container
        $('.duplicate-notice[data-position="'+pos+'"]').text('');
        // for styling purposes add a class to the grid container
        $item.closest('.vote_grid').addClass('touched');
        // change some classes
        $item.siblings().removeClass('chosen');
        $item.addClass('chosen').attr('data-unavailable', 0);
        // update chosen items
        updateChosenItems(current, item);
        // shift through accordion
        $('#collapse_1_' + pos).collapse('hide');
        if (pos !== 4) {
          $('#collapse_1_' + pos).on('hidden.bs.collapse', function () {
            $('#collapse_1_' + (pos + 1)).collapse('show');
          });
        }
      } else {
        $('.duplicate-notice[data-position="'+pos+'"]').text('Deze heb je al gekozen. Je mag niet meer dan 1 keer op hetzelfde boek stemmen');
      }
    } else {
      // for styling purposes add a class to the grid container
      $item.closest('.vote_grid').addClass('touched');
      // change some classes
      $item.siblings().removeClass('chosen');
      $item.addClass('chosen').attr('data-unavailable', 0);
      // close accordion
      $('#collapse_1_' + pos).collapse('hide');
      var item = {
        id: $item.data('postid'),
        position: $item.data('position'),
        title: $item.find('.vote_item_title').text(),
        author: $item.find('.vote_item_author').text()
      };
      updateDebutItem(item);
    }
  });

  $(document).on('click', '.submit-custom-vote', function(e) {
    e.preventDefault();
    var position = $(this).data('position');
    var $container = $('.accordion_item[data-position="'+position+'"]');
    var author = $container.find('[name="author"]').val();
    var title = $container.find('[name="title"]').val();
    var $voteItems = $container.find('.vote_item');
    var $current = $container.find('.vote_item.chosen');
    var current = false;
    $('.vote_form_wrapper input[type="submit"]').css('display', 'block');
    // if there's already a chosen item for this position, store it
    if ($current.length) {
      current = {
        id: $current.data('postid'),
        position: $current.data('position'),
        title: $current.find('.vote_item_title').text(),
        author: $current.find('.vote_item_author').text()
      };
    }
    // store new item
    var item = {
      id: 'custom-' + position,
      position: position,
      title: title,
      author: author
    };
    // check for duplicate
    var duplicate = false;
    $.each(chosenItems, function(key, value) {
      if (value.title.toLowerCase() === item.title.toLowerCase() && value.author.toLowerCase() === item.author.toLowerCase()) {
        duplicate = true;
      }
    });
    // if not duplicate process vote
    if (!duplicate) {
      // empty duplicate notice container
      $('.duplicate-notice[data-position="'+position+'"]').text('');
      // change some classes
      $container.find('.vote_grid').toggleClass('touched', !$container.find('.vote_grid').hasClass('touched'))
      $voteItems.removeClass('chosen');
      // update chosen item
      updateChosenItems(current, item);
      if (!duplicate) {
        // shift through accordion
        $('#collapse_1_' + position).collapse('hide');
        if (position !== 3) {
          $('#collapse_1_' + position).on('hidden.bs.collapse', function () {
            $('#collapse_1_' + (position + 1)).collapse('show');
          });
        }
      }
    } else {
      $('.duplicate-notice[data-position="'+position+'"]').text('Deze heb je al gekozen. Je mag niet meer dan 1 keer op hetzelfde boek stemmen');
    }
  });

  function updateChosenItems(oldItem, newItem) {
    // if there's an old item provided, delete it from the chosen items
    if (oldItem) {
    	delete chosenItems[oldItem.id];
      $('.vote_item[data-postid="'+oldItem.id+'"][data-position!="'+oldItem.position+'"]')
        .attr('data-unavailable', 0);
    }
    // add the new item to the chosen items
    chosenItems[newItem.id] = newItem;
    // make the chosen items unavailable for different positions
    $('.vote_item[data-postid="'+newItem.id+'"][data-position!="'+newItem.position+'"]')
      .not('[data-position=4]')
      .attr('data-unavailable', newItem.position)
      .removeClass('chosen')
      .closest('.vote_grid').removeClass('touched');
    // update the chosen items in the final form
    $('.main_vote_form').find('.vote_item:not([data-position="4"]).vote_item_title').text('Titel');
    $('.main_vote_form').find('.vote_item:not([data-position="4"]).vote_item_author').text('Auteur');
    $('.main_vote_form').find('.vote_item:not([data-position="4"]).book_cover > img').attr('src', placeholder);
    $.each(chosenItems, function(key, value) {
      var $voteItem = $('.main_vote_form').find('.vote_item[data-position="'+value.position+'"]');
      $voteItem.find('.vote_item_title').text(value.title);
      $voteItem.find('.vote_item_author').text(value.author);

      if (Number.isInteger(value.id)) {
        var coverSrc = $('.vote_item[data-postid="'+value.id+'"]').first().find('.book_cover > img').attr('src');
        $voteItem.find('.book_cover > img').attr('src', coverSrc);
      } else {
        $voteItem.find('.vote_item_cover img').attr('src', placeholder);
      }

      $('.gfield.choice_' + value.position + ' input').val(JSON.stringify({id: value.id, position: value.position, title: value.title, author: value.author}));
    });
  }

  function updateDebutItem(item) {
    var $voteItem = $('.main_vote_form').find('.vote_item[data-position="4"]');
    $voteItem.find('.vote_item_title').text(item.title);
    $voteItem.find('.vote_item_author').text(item.author);
    var coverSrc = $('.vote_item[data-postid="'+item.id+'"]').first().find('.book_cover > img').attr('src');
    $voteItem.find('.book_cover > img').attr('src', coverSrc);

    $('.gfield.choice_' + item.position + ' input').val(JSON.stringify({id: item.id, position: item.position, title: item.title, author: item.author}));
  }

});
